import { Input, InputProps, InputRef } from 'antd';
import React, { Ref } from 'react';
import { styled } from 'styled-components';
import { IMask } from 'antd-mask-input';
const PHONE_FORMAT = '(000) 000-0000';
const PHONE_MASKED = IMask.createMask({
  mask: PHONE_FORMAT,
  pattern: PHONE_FORMAT,
});

interface InputPhoneProps extends InputProps {
  inputRef?: Ref<InputRef>;
}
const InputPhone = ({ inputRef, ...props }: InputPhoneProps) => {
  return (
    <Styled
      {...props}
      ref={inputRef}
      onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
        const input = event.target as HTMLInputElement;
        input.value = PHONE_MASKED.resolve(input.value);
      }}
      maxLength={14}
    />
  );
};

export default InputPhone;

const Styled = styled(Input) <InputPhoneProps>``;
